<template>
    <div class="chart-page">
        <v-row>
            <v-col cols="3" sm="3" class="paddintp0">
                <div class="chart-indicator-pie">
                    <div class="multi-drop">
                        <!-- <v-select
                            :items="subjects"
                            v-model="selectedSubject"
                            @change="getSubjectScores"
                            label="Select Subject"
                            dense
                            hide-details
                            filled
                        ></v-select>-->
                        <multi-select
                            allText="All Subjects"
                            :items="subjects"
                            :onChange="getSubjectScores"
                            label="Select Subject"
                            dense
                            hide-details
                            filled
                        ></multi-select>
                    </div>
                    <div class="indicator-block top-indicator60">
                        <div class="indicator-color total-280"></div>
                        <div class="indicator-text">Your Scored a Total of {{marksScored}} Marks</div>
                    </div>
                    <div class="indicator-block">
                        <div class="indicator-color total-48"></div>
                        <div class="indicator-text">Out of Which You Lost {{marksLost}} Marks</div>
                    </div>
                </div>
            </v-col>
            <v-col cols="6" sm="6" class="paddintp0">
                <div v-if="series.length > 0">
                    <div class="pie-chart-block">
                        <PieChart :seriesData="series" :height="200" :chartOptions="chartOptions" />
                    </div>
                </div>
            </v-col>
            <!-- <v-col cols="3" sm="3" class="paddintp0">
                <div class="chart-top-btn-how">
                    <v-btn @click="howItWorks" class="how-sub-btn" outlined>How This Works</v-btn>
                </div>
            </v-col>-->
            <v-col cols="12" sm="12">
                <v-simple-table class="simple-table-auto">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Question Type</th>
                                <th class="text-center" >Marks Earned</th>
                                <th class="text-center" >Marks Lost</th>
                                <th class="text-center" >Your Score</th>
                                <th class="text-center" >Maximum Marks</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in questionData" :key="item.name">
                                <td>{{ item.type }}</td>
                                <td align="center">{{ item.marksEarned }}</td>
                                <td align="center">{{ item.markLost }}</td>
                                <td align="center">{{ item.yourMarks }}</td>
                                <td align="center">{{ item.maxMarks }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import PieChart from "@/components/Charts/PieChart.vue";

export default {
    name: "NegativeMarkingImpact",
    components: {
        PieChart
    },
    mounted() {
        this.getSubjects();
    },
    props: ["studentId"],
    computed: {
        ...mapState("userStore", ["user"])
    },
    data() {
        return {
            cComponent: "components/coordinator/AddBatch",
            alertBoxData: {},
            status: false,
            modalwidth: "700px",

            selectedSubject: null,
            marksScored: 0,
            marksLost: 0,
            is: 1,
            subjects: [],
            series: [],
            chartOptions: {
                chart: {
                    type: "pie"
                },
                labels: [],
                legend: {
                    show: false
                },
                fill: {},
                tooltip: {
                    enabled: false
                },
                states: {
                    hover: {
                        filter: {
                            type: "none"
                        }
                    }
                }
            },
            questionData: []
        };
    },
    methods: {
        ...mapActions({
            getTestSubjects: "resultStore/getTestSubjects",
            getScoreBySubjectId: "resultStore/getScoreBySubjectId"
        }),
        howItWorks() {
            this.cComponent = "components/student/HowItWorks";
            this.alertBoxData = {
                image: this.TESTWISEANALYSIS_TEST_TYPES.NEGATIVEMARKING
            };
            this.modalwidth = "70%";
            this.status = true;
            this.$forceUpdate();
        },
        onClose(data) {
            this.status = data.status;
        },
        getSubjects() {
            let test_id = this.$route.params.test_id;
            let reqData = { test_id, student_id: this.studentId };
            this.$root.showLoader = true;
            this.getTestSubjects(reqData)
                .then(response => {
                    this.subjects = response.map(s => {
                        return {
                            text: s.title,
                            value: { subject_id: s.id },
                            checked: false
                        };
                    });
                    this.subjects[0].checked = true;
                    let selectedSubject = [this.subjects[0].value];
                    this.getSubjectScores(selectedSubject);
                    this.$root.showLoader = false;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        getSubjectScores(selectedSubject) {
            this.series = [];
            this.questionData = [];
            this.marksScored = null;
            this.marksLost = null;
            if (selectedSubject.length == 0) return;
            let testInstituteId = this.$route.params.test_institute_id;
            let subjects = selectedSubject.map(subject => subject.subject_id);
            let postData = {
                subjects: subjects,
                test_id:this.$route.params.test_id,
                test_institute_id: testInstituteId,
                student_id: this.studentId
            };
            this.$root.showLoader = true;
            this.getScoreBySubjectId(postData)
                .then(response => {
                    this.processScoreData(response);
                    this.$root.showLoader = false;
                })
                .catch(err => {
                    this.$root.showLoader = false;
                });
        },
        processScoreData(response) {
            
            // Parse and format marks with 2 decimal places
            let marksEarned = parseFloat(response.total_marks_earned) || 0;
            // Handle malformed strings like "0-4.00" by replacing "0-" with "-"
            let marksLostStr = String(response.total_marks_lost).replace(/^0-/, '-');
            let marksLost = Math.abs(parseFloat(marksLostStr)) || 0;
            
            let currentScore = marksEarned - marksLost;
            
            this.marksScored = marksEarned.toFixed(2);
            this.marksLost = marksLost.toFixed(2);
            
            let totalForComparison = currentScore + marksLost;
            let marksScoredPerc = 0;
            let marksLostPerc = 0;
            
            if (totalForComparison > 0) {
                marksScoredPerc = (currentScore / totalForComparison) * 100;
                marksLostPerc = (marksLost / totalForComparison) * 100;
            }
            
            if (marksScoredPerc == 0 && marksLostPerc == 0) {
                this.series = [100];
                this.chartOptions.fill.colors = ["#efeeee"];
                this.chartOptions.tooltip.enabled = false;
            } else {
                this.series = [marksScoredPerc, marksLostPerc];
                this.chartOptions.fill.colors = ["#96ea96", "#ff7373"];
                // this.chartOptions.labels = ["Lost %", "Scored %"];
                // this.chartOptions.states.hover.filter.type = "lighten";
            }

            let questionData = [];
            response.details.forEach(q => {
                let queObj = {};
                queObj.type = q.question_type;
                queObj.marksEarned = parseFloat(q.marks_earned).toFixed(2);
                queObj.markLost = Math.abs(parseFloat(q.marks_lost)).toFixed(2);
                queObj.yourMarks = parseFloat(q.your_score).toFixed(2);
                queObj.maxMarks = parseFloat(q.maximum_marks).toFixed(0);
                questionData.push(queObj);
            });
            this.questionData = questionData;
        }
    }
};
</script>